import type { TiptapEditorPlugin } from 'ricos-types';

import { notOvertypable } from './extension';

export const pluginNotOvertypable: TiptapEditorPlugin = {
  type: 'NOT_OVERRIDABLE',
  config: {},
  tiptapExtensions: [notOvertypable],
};
